export default "__VITE_ASSET__BB9hvNAI__"